/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StaffRouteImport } from './routes/_staff'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as VenueSlugRouteImport } from './routes/$venueSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VenueSlugIndexRouteImport } from './routes/$venueSlug/index'
import { Route as StaffStaffIndexRouteImport } from './routes/_staff/staff/index'
import { Route as AuthAuthStaffIndexRouteImport } from './routes/_auth/auth/staff/index'
import { Route as AuthAuthVenueSlugIndexRouteImport } from './routes/_auth/auth/$venueSlug/index'
import { Route as AuthAuthTokenEmailTokenRouteImport } from './routes/_auth/auth/token.$email.$token'

const StaffRoute = StaffRouteImport.update({
  id: '/_staff',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const VenueSlugRoute = VenueSlugRouteImport.update({
  id: '/$venueSlug',
  path: '/$venueSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenueSlugIndexRoute = VenueSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => VenueSlugRoute,
} as any)
const StaffStaffIndexRoute = StaffStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => StaffRoute,
} as any)
const AuthAuthStaffIndexRoute = AuthAuthStaffIndexRouteImport.update({
  id: '/auth/staff/',
  path: '/auth/staff/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthVenueSlugIndexRoute = AuthAuthVenueSlugIndexRouteImport.update({
  id: '/auth/$venueSlug/',
  path: '/auth/$venueSlug/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthTokenEmailTokenRoute = AuthAuthTokenEmailTokenRouteImport.update({
  id: '/auth/token/$email/$token',
  path: '/auth/token/$email/$token',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$venueSlug': typeof VenueSlugRouteWithChildren
  '/$venueSlug/': typeof VenueSlugIndexRoute
  '/staff/': typeof StaffStaffIndexRoute
  '/auth/$venueSlug/': typeof AuthAuthVenueSlugIndexRoute
  '/auth/staff/': typeof AuthAuthStaffIndexRoute
  '/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$venueSlug': typeof VenueSlugIndexRoute
  '/staff': typeof StaffStaffIndexRoute
  '/auth/$venueSlug': typeof AuthAuthVenueSlugIndexRoute
  '/auth/staff': typeof AuthAuthStaffIndexRoute
  '/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$venueSlug': typeof VenueSlugRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_staff': typeof StaffRouteWithChildren
  '/$venueSlug/': typeof VenueSlugIndexRoute
  '/_staff/staff/': typeof StaffStaffIndexRoute
  '/_auth/auth/$venueSlug/': typeof AuthAuthVenueSlugIndexRoute
  '/_auth/auth/staff/': typeof AuthAuthStaffIndexRoute
  '/_auth/auth/token/$email/$token': typeof AuthAuthTokenEmailTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$venueSlug'
    | '/$venueSlug/'
    | '/staff/'
    | '/auth/$venueSlug/'
    | '/auth/staff/'
    | '/auth/token/$email/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$venueSlug'
    | '/staff'
    | '/auth/$venueSlug'
    | '/auth/staff'
    | '/auth/token/$email/$token'
  id:
    | '__root__'
    | '/'
    | '/$venueSlug'
    | '/_auth'
    | '/_staff'
    | '/$venueSlug/'
    | '/_staff/staff/'
    | '/_auth/auth/$venueSlug/'
    | '/_auth/auth/staff/'
    | '/_auth/auth/token/$email/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  VenueSlugRoute: typeof VenueSlugRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  StaffRoute: typeof StaffRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_staff': {
      id: '/_staff'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$venueSlug': {
      id: '/$venueSlug'
      path: '/$venueSlug'
      fullPath: '/$venueSlug'
      preLoaderRoute: typeof VenueSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$venueSlug/': {
      id: '/$venueSlug/'
      path: '/'
      fullPath: '/$venueSlug/'
      preLoaderRoute: typeof VenueSlugIndexRouteImport
      parentRoute: typeof VenueSlugRoute
    }
    '/_staff/staff/': {
      id: '/_staff/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof StaffStaffIndexRouteImport
      parentRoute: typeof StaffRoute
    }
    '/_auth/auth/staff/': {
      id: '/_auth/auth/staff/'
      path: '/auth/staff'
      fullPath: '/auth/staff/'
      preLoaderRoute: typeof AuthAuthStaffIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/$venueSlug/': {
      id: '/_auth/auth/$venueSlug/'
      path: '/auth/$venueSlug'
      fullPath: '/auth/$venueSlug/'
      preLoaderRoute: typeof AuthAuthVenueSlugIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/token/$email/$token': {
      id: '/_auth/auth/token/$email/$token'
      path: '/auth/token/$email/$token'
      fullPath: '/auth/token/$email/$token'
      preLoaderRoute: typeof AuthAuthTokenEmailTokenRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface VenueSlugRouteChildren {
  VenueSlugIndexRoute: typeof VenueSlugIndexRoute
}

const VenueSlugRouteChildren: VenueSlugRouteChildren = {
  VenueSlugIndexRoute: VenueSlugIndexRoute,
}

const VenueSlugRouteWithChildren = VenueSlugRoute._addFileChildren(
  VenueSlugRouteChildren,
)

interface AuthRouteChildren {
  AuthAuthVenueSlugIndexRoute: typeof AuthAuthVenueSlugIndexRoute
  AuthAuthStaffIndexRoute: typeof AuthAuthStaffIndexRoute
  AuthAuthTokenEmailTokenRoute: typeof AuthAuthTokenEmailTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthVenueSlugIndexRoute: AuthAuthVenueSlugIndexRoute,
  AuthAuthStaffIndexRoute: AuthAuthStaffIndexRoute,
  AuthAuthTokenEmailTokenRoute: AuthAuthTokenEmailTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface StaffRouteChildren {
  StaffStaffIndexRoute: typeof StaffStaffIndexRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffStaffIndexRoute: StaffStaffIndexRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VenueSlugRoute: VenueSlugRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
